
export default "/assets/tag-mini.5c1911c2.svg"